import {ActivatedRouteSnapshot, CanActivate} from '@angular/router';
import {Injectable} from '@angular/core';

import {Observable, of} from 'rxjs';
import {catchError, filter, switchMap, take, tap} from 'rxjs/operators';
import {select, Store} from '@ngrx/store';

import {ApplicationState} from '../../application-state/store';
import {CancellationInvoicesSelectors} from '../store/selectors';
import {CancellationInvoicesActions} from '../store';

@Injectable()
export class CurrentCancellationInvoiceLoadedGuard implements CanActivate {

  constructor(private store: Store<ApplicationState>) {
  }

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {

    const iri = route.params.iri;

    return this.currentCancellationInvoiceLoaded(iri).pipe(
      switchMap(() => of(true)),
      catchError(() => of(false))
    );
  }

  currentCancellationInvoiceLoaded(iri: string): Observable<boolean | any> {
    return this.store.pipe(
      select(CancellationInvoicesSelectors.selectCurrentCancellationInvoice),
      tap(invoice => {
        if (!invoice) {
          this.store.dispatch(CancellationInvoicesActions.ReadCancellationInvoice({iri}));
        }
      }),
      filter(invoice => !!invoice),
      take(2)
    );
  }
}
